import script from "./FamilyListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyListItem.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyListItem.vue?vue&type=style&index=0&id=0b129cf8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b129cf8"]])

export default __exports__